<div class="row">
     <div class="col-12">
          <div class="row justify-content-between align-items-center" id="page-title">
               <h1 class="progress-header col-12 col-lg-auto" [innerHtml]="'Enroll in PSP_MAIN' | translator:'base'">
               </h1>
          </div>
          <div class="row mb-2">
               <span class="col-12 col-lg-auto d-flex align-items-center small">
                    <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
                    <span [innerHtml]="'Start_8-1' | translator:'base'">
                         Are you a <strong>driver</strong> looking for your own PSP record?
                    </span>
                    <a routerLink="/driver/1" (click)="scrollToTop()" name="Driver-record-request"
                         id="Driver-record-request" [title]="'Start_8-2' | translator:'base'" class="ms-1">
                         <span [innerHtml]="'Start_8-2' | translator:'base'">Access your PSP record
                              here.</span>
                    </a>
               </span>
          </div>
          <div class="row">
               <div class="col-lg-8">
                    <div class="card shadow-sm rounded-0 border-0">
                         <div class="card-body">
                              <app-complete-bar [step]="5" [totalSteps]="19"></app-complete-bar>
                              <h2 [innerHtml]="'ISP_1' | translator:'base'">INDUSTRY SERVICE PROVIDER</h2>
                              <p><span [innerHtml]="'ISP_2' | translator:'base'">Please share your estimated
                                        volume.</span></p>
                              <hr>
                              <div class="mb-3" [formGroup]="companyInfo">
                                   <label class="form-label" for="ISPCarrierCount">
                                        <span [innerHtml]="'ISP_3' | translator:'base'">Approximate number of motor
                                             carrier customers?</span>
                                        <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
                                   </label>
                                   <input type="number"
                                        formControlName="ispEstimatedCustomers"
                                        name="ISPCarrierCount" id="ISPCarrierCount"
                                        [ngClass]="{ 'form-control': true, 'bg-light': true, 'input-number': true }"
                                        step="1" />
                                   <div *ngIf="ispEstimatedCustomers!.invalid && ispEstimatedCustomers!.dirty"  > 
                                        <span class="help-block text-danger d-block"
                                             *ngIf="ispEstimatedCustomers!.errors?.['pattern'] || ispEstimatedCustomers!.errors?.['max'] || ispEstimatedCustomers!.errors?.['min']"
                                             [innerHtml]="'ISPCarrierCount' | translator:'base'">
                                             Approximate motor carrier customers can only be a whole number between 1 and
                                             999,999,999.
                                        </span>
                                        <span class="help-block text-danger d-block"
                                             *ngIf="ispEstimatedCustomers!.errors?.['required']"
                                             [innerHtml]="'ISP_Num_MC_Req' | translator:'base'">
                                             Number of Motor Carriers is required.
                                        </span>
                                   </div>  
                              </div>
                              <div class="" [formGroup]="companyInfo">
                                   <label class="form-label" for="ISPDriverCount">
                                        <span [innerHtml]="'ISP_3_a' | translator:'base'">Approximate number of drivers
                                             screened annually?</span>
                                        <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
                                   </label>
                                   <input type="number" formControlName="ispAnnualScreenings"
                                        name="ISPDriverCount" id="ISPDriverCount"
                                        [ngClass]="{ 'form-control': true, 'bg-light': true, 'input-number': true }"
                                        step="1" />
                                   <div *ngIf="ispAnnualScreenings!.invalid && ispAnnualScreenings!.dirty"  >
                                        <span class="help-block text-danger d-block"
                                             *ngIf="ispAnnualScreenings!.errors?.['pattern'] || ispAnnualScreenings!.errors?.['min'] || ispAnnualScreenings!.errors?.['max']"
                                             [innerHtml]="'ISPDriverCount' | translator:'base'">
                                             Approximate number of drivers screened annually can only be a whole number
                                             between 1 and 999,999,999.
                                        </span>
                                        <span class="help-block text-danger d-block"
                                             *ngIf="ispAnnualScreenings!.errors?.['required']"
                                             [innerHtml]="'ISP_Num_Driver_Req' | translator:'base'">
                                             Number of drivers is required.
                                        </span>
                                   </div>
                              </div>
                              <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                                   <div class="btn-group" role="group">
                                        <button class="btn btn-primary btn-strong" [disabled]="(ispAnnualScreenings!.invalid || ispEstimatedCustomers!.invalid) ? 'true' : null" 
                                             [title]="'ISPInfo' | translator:'base'" name="companyNext7"
                                             id="companyNext7" routerLink="/signup/9" (click)="scrollToTop()">
                                             
                                             <span [innerHtml]="'Continue' | translator:'base'">Continue</span>
                                             <span class="sr-only">&nbsp;</span>
                                             <span class="sr-only" [innerHtml]="'ISPInfo' | translator:'base'">Industry
                                                  Service Provider Info</span>
                                        </button>
                                   </div>
                                   <div class="btn-group" role="group">
                                        <button routerLink="/signup/6" class="btn btn-outline-primary"
                                             [title]="'ISPInfo' | translator:'base'" name="companyBack7"
                                             id="companyBack7">
                                             <span [innerHtml]="'Back' | translator:'base'">Back</span>
                                             <span class="sr-only" [innerHtml]="'ISPInfo' | translator:'base'">Industry
                                                  Service Provider Info</span>
                                        </button>
                                        <button routerLink="/" tag="button" class="btn btn-light" (click)="scrollToTop()"
                                             name="companyCancel7" id="companyCancel7"
                                             [innerHtml]="'Cancel' | translator:'base'"
                                             [title]="'Cancel' | translator:'base'">Cancel
                                        </button>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
               <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="2"
                    [pageType]="enrollmentService.newCustomer!.customerType || '-'"
                    class="col-lg-4 sidebar d-none d-lg-block" d></app-progress-wizard>
          </div>
     </div>
</div>